module.exports = __webpack_public_path__ + "static/media/bb.e9f2db2f.svg";